import styled from 'styled-components';

import { primitive } from 'styles/constants/primitives';

export const Table = styled.table`
  margin-block-start: 1.5rem;
  width: 100%;
  border-collapse: collapse;
`;

export const TableHead = styled.thead``;

export const TableTitle = styled.th`
  font-size: 0.875rem;
  font-weight: ${Styles.fontWeight.heavy};
  border-block-end: 1px solid ${Styles.color.grey.five};
  text-align: start;

  ${Styles.desktop} {
    font-size: 1rem;
  }
`;

export const TableRow = styled.tr`
  align-items: center;
`;

export const TableData = styled.td`
  font-size: 0.875rem;
  text-align: start;
  font-weight: normal;
  padding-block-end: ${primitive.$spacing2};

  tr:first-of-type & {
    padding-block-start: ${primitive.$spacing4};
  }

  ${Styles.desktop} {
    font-size: 1rem;
  }
`;
